/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState, useEffect, useRef } from 'react';
import './CSS/trends.css';
import Line from './Widgets/Line';
import TableComponent from './Widgets/Table';
import { connect } from 'react-redux';
import { getTrendData } from './ChartCalls';
import FilterComponent from './FilterComponent';
import NoRecordComponent from './Utils/NoRecords';
import { Spin, Row, Col, Radio, message, DatePicker, Typography } from 'antd';
import { getThemeValue } from '../../commons/styles/dynamicValues';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { StyledHomepage } from '../../commons/styles/layout';
const { RangePicker } = DatePicker;
const color = [
  'orange',
  'tomato',
  'steelblue',
  'green',
  'pink',
  'voilet',
  'yellow',
  'red',
  'blue',
  'gray'
];
const Trends = (props) => {

  const [trendData, setTrendData] = useState([]);
  const [tunedData, setTunedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentSelectionTab, setCurrentSelectionTab] = useState('day');
  const [graphType, setGraphType] = useState('line');
  const [viewType, setViewType] = useState("");
  const [userProfile, setUserProfile] = useState(props.userProfile);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [type, setType] = useState('live');
  // const [selectedParameter, setSelectedParameter] = useState([]);
  const [selectedParameterType, setSelectedParameterType] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedFromDate_ToDate, setSelectedFromDate_ToDate] = useState([]);
  const [selectedFromDate_ToDate1, setSelectedFromDate_ToDate1] = useState([]);
  const [filterObject, setFilterObject] = useState([]);
  const [source, setSource] = useState('');
  const [update, setUpdate] = useState(false);
  const [selectedDateRangeComparision, setSelectedDateRangeComparision] = useState([]);
  // const formHeader = useRef();
  const abortController = useRef(new window.AbortController());
  let timeTicket = useRef(null);
  dayjs.extend(utc);

  useEffect(() => {

    if (translationCache !== props.translationCache || userProfile !== props.userProfile) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }
    if (tunedData !== props.tunedData) {
      OnGenerateTrendData(props.tunedData, {}, 'ViewTrends');
    }
  }, [props.translationCache, props.userProfile, props.tunedData]);

  useEffect(() => {
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  const OnGenerateTrendData = async (tunedData, filterObject, source, selectedOption, currentTab) => {

    if (currentTab && currentTab !== undefined) {
      setCurrentSelectionTab(currentTab);
    }

    if (tunedData && Object.keys(tunedData).length > 0) {
      let SelectedParameterType = filterObject && filterObject.selectedParameterType;
      setSource(source);
      // setRequestCheck(false);
      setViewType(tunedData.ViewType);
      setTunedData(tunedData);
      setGraphType('line');
      setType(tunedData.Type);
      setSelectedParameterType(SelectedParameterType);
      getTrendDataAPI(tunedData, filterObject, source, selectedOption);
      setSelectedOption(selectedOption);
      if (timeTicket) {
        clearInterval(timeTicket);
      }

    } else {
      resetState();
    }
  };

  const resetState = () => {
    setTrendData([]);
    setTunedData({});
    setLoading(false);
    setCurrentSelectionTab('day');
    setGraphType('line');
    setViewType('Single');
    setType('live');
    // setSelectedParameter([]);
    setSelectedParameterType([]);
    // setSelectedInterval('');
    setSelectedFromDate_ToDate([]);
    setSelectedFromDate_ToDate1([]);
    setSelectedDateRangeComparision([]);
  };
  const getTrendDataAPI = async (tunedData, filterObject, source, selectedOption) => {

    let trendData = await getTrendData(tunedData, selectedOption, abortController.current);
    // setTunedData(tunedData);

    setSelectedFromDate_ToDate1([
      dayjs.utc(tunedData.FromDate, 'YYYY-MM-DD HH:mm:ss').local(),
      dayjs.utc(tunedData.ToDate, 'YYYY-MM-DD HH:mm:ss').local()
    ]);
    setSelectedFromDate_ToDate([
      dayjs.utc(tunedData.FromDate1, 'YYYY-MM-DD HH:mm:ss').local(),
      dayjs.utc(tunedData.ToDate1, 'YYYY-MM-DD HH:mm:ss').local()
    ]);
    setSelectedDateRangeComparision([
      dayjs.utc(tunedData.FromDate2, 'YYYY-MM-DD HH:mm:ss').local(),
      dayjs.utc(tunedData.ToDate2, 'YYYY-MM-DD HH:mm:ss').local()
    ]);
    if (viewType && viewType === 'Single') {
      if (trendData && Array.isArray(trendData)) {
        setFilterObject(filterObject);
        setTrendData(trendData);
        setLoading(loading);
        setGraphType(tunedData.GraphType);
        // setPayLoad(tunedData);
        setTunedData(tunedData);
        setUpdate(true);
        setSource(source);
        // () => {
        //   setRequestCheck(true);
        // };
      } else {
        // setRequestCheck(true);
        setLoading(false);
        setTrendData([]);
        message.error('Data is not available for selected parameters');
      }
    } else {

      if (trendData && trendData.length > 0) {
        if (trendData.length > 0) {
          setFilterObject(filterObject);
          setTrendData(trendData);
          setTunedData(tunedData);
          setGraphType(tunedData.GraphType);
          setUpdate(true);
          setSource(source);

          // () => {
          //   setRequestCheck(true);
          // };

        } else {

          setFilterObject(filterObject);
          setTrendData(trendData);
          setLoading(loading);
          // setPayLoad(tunedData);
          setTunedData(tunedData);
          setUpdate(true);
          setSource(source);
          // () => {
          //   setRequestCheck(true);
          // };

        }
      } else {
        // setRequestCheck(true);
        setLoading(false);
        setTrendData([]);
        message.warn('Data is not available for selected parameters');
      }
    }
  };
  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onSelectionTabChange = (e) => {
    setCurrentSelectionTab(e.target.value);

    let TunedData = {
      ...tunedData,
      SelectionType: e.target.value,
      source,
      selectedOption

    };
    OnGenerateTrendData(TunedData, filterObject, source, selectedOption);

    // OnGenerateTrendData({ ...tunedData, SelectionType: e.target.value });
  };

  const disabledDate = (current) => {
return current && current > dayjs();
  };
  const onChangeFromDate_ToDate = (value, dateString) => {
    let selectedFromDate_ToDate = [
      dayjs(dateString[0]).format('YYYY-MM-DD HH:mm:ss'),
      dayjs(dateString[1]).format('YYYY-MM-DD HH:mm:ss')
    ];
    // setSelectedFromDate_ToDate(selectedFromDate_ToDate);
    let updatedTunedData = {
      ...tunedData,
      FromDate1: dayjs(selectedFromDate_ToDate[0]).utc().format('YYYY-MM-DD HH:mm:ss'),
      ToDate1: dayjs(selectedFromDate_ToDate[1]).utc().format('YYYY-MM-DD HH:mm:ss')
    };
    let updatedFilterObject = {
      ...filterObject,
      selectedFromDate_ToDate: [value[0], value[1]]
    };

    OnGenerateTrendData(updatedTunedData, updatedFilterObject, source, selectedOption);
  };

  const onChangeFromDate_ToDate1 = (value, dateString) => {
    try {
      let selectedFromDate_ToDate1 = [
        dayjs(dateString[0]).format('YYYY-MM-DD HH:mm:ss'),
        dayjs(dateString[1]).format('YYYY-MM-DD HH:mm:ss')
      ];
      // setSelectedFromDate_ToDate1(selectedFromDate_ToDate1);

      let updatedTunedData = {
        ...tunedData,
        FromDate: dayjs(selectedFromDate_ToDate1[0]).utc().format('YYYY-MM-DD HH:mm:ss'), // conversion to utc
        ToDate: dayjs(selectedFromDate_ToDate1[1]).utc().format('YYYY-MM-DD HH:mm:ss')
      };
      let updatedFilterObject = {
        ...filterObject,
        selectedFromDate_ToDate1: [value[0], value[1]]
      };
      OnGenerateTrendData(updatedTunedData, updatedFilterObject, source, selectedOption);
    } catch (err) {
      console.log(err);
    }
  };
  const onChangeFromDate1_ToDate1 = (value, dateString) => {
    try {
      let selectedDateRangeComparision = [
        dayjs(dateString[0]).format('YYYY-MM-DD HH:mm:ss'),
        dayjs(dateString[1]).format('YYYY-MM-DD HH:mm:ss')
      ];
      // setSelectedDateRangeComparision(selectedDateRangeComparision);

      let updatedTunedData = {
        ...tunedData,
        FromDate2: dayjs(selectedDateRangeComparision[0]).utc().format('YYYY-MM-DD HH:mm:ss'), // conversion to utc
        ToDate2: dayjs(selectedDateRangeComparision[1]).utc().format('YYYY-MM-DD HH:mm:ss')
      };

      let updatedFilterObject = {
        ...filterObject,
        selectedDateRangeComparision: [value[0], value[1]]
      };
      OnGenerateTrendData(updatedTunedData, updatedFilterObject, source, selectedOption);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <StyledHomepage>
      <Row>
        <Col
          span={source && source === 'ViewTrends' ? 24 : 16}
          push={source && source === 'ViewTrends' ? 0 : 8}
        >
          <div
          >
            {tunedData && Object.keys(tunedData).length > 0 ? (
              <div style={{ height: viewType === 'Multiple' ? '100%' : '120vh', padding: '15px' }}>
                {loading === true ? (
                  <div style={{ textAlign: 'center', color: 'white' }}>
                    <h2 style={{ color: 'white' }}>
                      <Spin spinning={loading} tip="Loading..."  />
                    </h2>
                  </div>
                ) : trendData && Array.isArray(trendData) ? (
                  <React.Fragment>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: '20px' }}>
                      {(selectedParameterType &&
                        selectedParameterType !== undefined &&
                        selectedParameterType !== 'Status' || selectedParameterType !== "Fault") ||
                        (source === 'ViewTrends' &&
                          tunedData &&
                          tunedData.GraphType !== 'Table') ? (

                        <Radio.Group
                          onChange={(e) => setGraphType(e.target.value)}
                          value={graphType}
                          // buttonStyle='solid'
                        >
                          <Radio.Button value="line">{translation('Line')}</Radio.Button>
                          <Radio.Button value="bar">{translation('Bar')}</Radio.Button>
                          <Radio.Button value="Area">{translation('Area')}</Radio.Button>
                          <Radio.Button value="Table">{translation('Table')}</Radio.Button>
                        </Radio.Group>
                      ) : null}
                    </div>
                    {type === 'historic' ? (
                      <div style={{ display: 'flex', flexDirection: 'row-reverse', paddingBottom: '0px 20px' }}>
                        <RangePicker
                          showTime={{ format: 'HH:mm:ss' }}
                          format="YYYY-MM-DD HH:mm:ss"
                          placeholder={[
                            translation('Start DateTime'),
                            translation('End DateTime')
                          ]}
                          value={selectedFromDate_ToDate1}
                          onChange={onChangeFromDate_ToDate1}
                          // onOk={onOk}
                          disabledDate={disabledDate}
                        />
                      </div>
                    ) : null}
                    {type === 'timeRange' ? (
                      <div style={{ display: 'flex', flexDirection: 'row-reverse', paddingBottom: '0px 20px' }}>
                        <RangePicker
                          showTime={{ format: 'HH:mm:ss' }}
                          format="YYYY-MM-DD HH:mm:ss"
                          placeholder={[
                            translation('Start DateTime'),
                            translation('End DateTime')
                          ]}
                          value={selectedDateRangeComparision}
                          onChange={onChangeFromDate1_ToDate1}
                          // onOk={onOk}
                          disabledDate={disabledDate}
                        />
                        <RangePicker
                          showTime={{ format: 'HH:mm:ss' }}
                          format="YYYY-MM-DD HH:mm:ss"
                          placeholder={[
                            translation('Start DateTime'),
                            translation('End DateTime')
                          ]}
                          value={selectedFromDate_ToDate}
                          onChange={onChangeFromDate_ToDate}
                          // onOk={onOk}
                          disabledDate={disabledDate}
                        />
                      </div>
                    ) : null}
                    {type === 'timeWithSelectionType' ? (
                      <div style={{ display: 'flex', flexDirection: 'row-reverse', paddingBottom: '0px 20px' }}>
                        <RangePicker
                          showTime={{ format: 'HH:mm:ss' }}
                          format="YYYY-MM-DD HH:mm:ss"
                          placeholder={[
                            translation('Start DateTime'),
                            translation('End DateTime')
                          ]}
                          value={selectedFromDate_ToDate1}
                          onChange={onChangeFromDate_ToDate1}
                          // onOk={onOk}
                          disabledDate={disabledDate}
                        />
                      </div>
                    ) : null}
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: '20px' }}>
                      {type === 'timeWithSelectionType' ? (
                        <Radio.Group
                          value={currentSelectionTab}
                          onChange={onSelectionTabChange}
                        >
                          <Radio.Button value="day">{translation('Daily')}</Radio.Button>
                          <Radio.Button value="week">{translation('Week')}</Radio.Button>
                          <Radio.Button value="month">{translation('Month')}</Radio.Button>
                          <Radio.Button value="year">{translation('Year')}</Radio.Button>
                        </Radio.Group>
                      ) : null}
                    </div>
                    {
                      <>
                        {viewType && viewType === 'Single' ? (
                          <>
                            {graphType !== 'Table' ? (
                              <Line
                                graphType={graphType}
                                selectedType={selectedOption}
                                panelData={{
                                  graph: 'trends',
                                  trendData: trendData,
                                  colors: color,
                                  linetype: '',
                                  update: update,
                                  Type: type,
                                  tunedData: tunedData,
                                  parameterType: filterObject && filterObject.selectedParameterType
                                }}
                                currentTimeZone={props.currentTimeZone}
                              />
                            ) : (
                              <div style={{ height: '125vh' }}>
                                <TableComponent
                                  selectedType={selectedOption}
                                  panelData={{
                                    graph: 'trends',
                                    trendData: trendData,
                                    colors: color,
                                    linetype: '',
                                    update: update,
                                    Type: type,
                                    tunedData: tunedData
                                  }}
                                  currentTimeZone={props.currentTimeZone}
                                  dataSource={trendData}
                                  translationCache={props.translationCache}
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            {graphType !== 'Table' ? (
                              <span style={{ overflowY: 'auto', height: window.innerHeight - 215 }}>
                                {trendData && Array.isArray(trendData) && trendData.map((graphData, i) => (

                                  <div key={i} style={{ height: '68vh', marginTop: '1%', marginBottom: '-250px' }}>
                                    {graphData && Array.isArray(graphData) && graphData.length > 0 ? (
                                      <Line
                                        graphType={graphType}
                                        selectedType={selectedOption}
                                        panelData={{
                                          graph: 'trends',
                                          trendData: graphData,
                                          tunedData: tunedData,
                                          colors: [color[i]],
                                          linetype: '',
                                          update: update,
                                          Type: type,
                                          trendIndex: i,
                                          parameterType: filterObject && filterObject.selectedParameterType
                                        }}
                                        viewType={viewType}
                                        currentTimeZone={props.currentTimeZone}
                                      />
                                    ) : (
                                      <div style={{ width: '100%', height: '48vh' }}>
                                        <NoRecordComponent />
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </span>
                            ) : (
                              <span style={{ overflowY: 'auto', height: window.innerHeight - 215 }}>
                                {trendData && Array.isArray(trendData) && trendData.map((trend, index) => (
                                  <div key={index} style={{ marginTop: '40px' }}>
                                    <TableComponent
                                      selectedType={selectedOption}
                                      panelData={{
                                        graph: 'trends',
                                        trendData: trend,
                                        colors: color,
                                        update: update,
                                        Type: type,
                                        tunedData: tunedData,
                                        trendIndex: index
                                      }}
                                      currentTimeZone={props.currentTimeZone}
                                      dataSource={trendData}
                                      viewType={viewType}
                                    />
                                  </div>
                                ))}
                              </span>
                            )}
                          </>
                        )}
                      </>
                    }
                  </React.Fragment>
                ) : (
                  <Typography.Title level={4} style={{ textAlign: 'center', marginTop: "40vh" }}>
                    {translation('Configure To View Trends')}
                  </Typography.Title>
                )}
              </div>
            ) : (
              <Typography.Title level={4} style={{ textAlign: 'center', marginTop: "40vh" }}>
                {translation('Configure To View Trends')}
              </Typography.Title>
            )}
          </div>
        </Col>
        {source && source === 'ViewTrends' ? null : (
          <Col span={8} pull={16}>
            <div
              style={{
                padding: '20px',
                borderRight: `1px solid ${getThemeValue(props.theme?.algorithm)}`,
                minHeight: window.innerHeight - 73
              }}
            >
              <FilterComponent
                {...props}
                OnGenerateTrendData={OnGenerateTrendData}
                GraphType={graphType}
              />
            </div>
          </Col>
        )}
      </Row>
    </StyledHomepage>
  );
};
const mapStateToProps = (state) => ({
  theme: state.ThemeReducer,
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});
export default connect(mapStateToProps)(Trends);
